// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Switch_wrapper__iB1XZ","switch":"Switch_switch__36Zrj","dark":"Switch_dark__3N68L"};